import React from 'react';
import Modal from '@mui/material/Modal';
import ButtonBase from '@mui/material/ButtonBase';
import styles from './PhysCreatePromptModal.module.scss';

const PhysCreatePromptModalContainer = (props) => {

    const {modalOpen, handleClickNo, handleClickYes, handleCloseModal} = props;

    const handleCustomClose = () => {
        handleCloseModal()
        handleClickNo()
    }

    return (
        <Modal open={modalOpen} onClose={handleCustomClose}>
          <div className={styles.root}>
            <h2 className="ttl ttl-2">
              Would you like to create a physician?
            </h2>
            <div className={`${'buttonGroup'} ${styles.buttonGroup}`}>
              <ButtonBase
                  className="button formButton formButton__secondaryOutlined"
                  onClick={handleCustomClose}>
                No
              </ButtonBase>
              <ButtonBase
                  className="button formButton formButton__mainContained"
                  onClick={handleClickYes}
              >
                Yes
              </ButtonBase>
            </div>
          </div>
        </Modal>
    );

}

export default PhysCreatePromptModalContainer;